$(document).ready(function() {
  var $accountNav = $('[data-account-nav]');
  $accountNav.on('change', function() {
    if ( $(this).val().charAt(0) == '/'){
      window.location = $(this).val();
      return;
    }
    var id = '#' + $(this).val();
    $([document.documentElement, document.body]).animate({
        scrollTop: $(id).offset().top - 120
      },
      700
    );
  });

  $('.yotpo-display-wrapper').each(function() {
    console.log('.yotpo-display-wrapper', $(this).is(':hidden'))
    if ($(this).is(':hidden')){
      $(this).parent('.reviews-wrap').append('<p>No reviews</p>');
    }
  });

  $('.view-basket').click(function() {
    $('.cart-header').trigger('click');
    return false;
  });

  $('.magnific-popup').magnificPopup({
    type:'inline',
    closeBtnInside:true
  });

  $('a.steps-how-to').on('click', function(){
    console.log('how to toggle')
    $(this).parent().parent().find('.how-to-hidden').toggleClass('invisible');
    return false;
  });
});
